import { Component, HostListener, OnInit } from "@angular/core";
import { LanguageService } from '@core/services';
import { IFlag } from '@core/interfaces';

@Component({
    selector: 'app-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.css']
})
export class FlagComponent implements OnInit {

    public Items: Array<IFlag> = this.languageService.supportedLanguages;

    public showSelect: boolean = false;

    public selectedItem: IFlag;

    constructor(
        private languageService: LanguageService) {

    }
    ngOnInit(): void {
        const lang = this.languageService.currentLanguage.getValue();
        this.selectedItem = this.languageService.getLanguageByCulture(lang) || this.Items[0];
        this.languageService.currentLanguage.subscribe(language => {
            this.selectedItem = this.languageService.getLanguageByCulture(language) || this.Items[0];
        });
    }

    private wasInside = true;

    @HostListener('click')
    clickInside() {
        this.wasInside = true;
    }

    @HostListener('document:click')
    clickout() {
        if (!this.wasInside) {
            this.closeSelectList();
        }
        this.wasInside = false;
    }

    public toggleItems() {
        this.showSelect = !this.showSelect;
    }

    public closeSelectList() {
        this.showSelect = false;
    }


    public selectItem(item: IFlag): void {
        this.selectedItem = item;
        this.languageService.changeLanguage(item.Culture).subscribe();
        this.closeSelectList();
    }
}
